import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { StepperButtons } from "../buttons";
import { StepperSidebar } from "../sidebar";
import { Input } from "@/components/ui/input";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import {
  getDealProvidersMultiSelectOptions,
  getDealRolesMultiSelectOptions,
  getDealTypesMultiSelectOptions,
} from "@/lib/app";
import { z } from "zod";
import { useFieldArray, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "@/components/ui/button";
import { Plus, XIcon } from "lucide-react";
// import { QuotaCombobox } from "@/plans/edit/accelerators/components/quota-combobox";
import { FilterCombobox } from "@/plans/edit/accelerators/components/filter-combobox";
import { ConditionCombobox2 } from "@/plans/edit/accelerators/components/condition-combobox-2";
import { MultiSelect } from "@/components/ui/multi-select";
import { Field, FieldContent, FieldGroup, FieldLabel, FieldLegend, FieldSet, FieldTitle } from "@/components/ui/field";
import { useStepper } from "@/components/ui/stepper";

const dealSelectorSchema = z.object({
  metric: z.string(),
  data_field: z.string(),
  custom_data_field: z.string(),
  // quotas: z.array(
  //   z.object({
  //     id: z.number().optional(),
  //     key: z.object({
  //       key_name: z.string({
  //         required_error: "Please select a key.",
  //       }),
  //       quota_id: z.number().optional(),
  //     }),
  //     operator: z.string({
  //       required_error: "Please select an operator.",
  //     }),
  //     value: z.string({
  //       required_error: "Please set a value.",
  //     }),
  //     value_from: z.string({
  //       required_error: "Please set a value.",
  //     }),
  //     value_to: z.string({
  //       required_error: "Please set a value.",
  //     }),
  //     value_list: z.string({
  //       required_error: "Please set a value.",
  //     }),
  //     value_arr: z.array(z.string()),
  //   })
  //     .optional()
  // )
  //   .optional(),
  filters: z
    .array(
      z
        .object({
          id: z.number().optional(),
          key: z.object({
            key_name: z.string({
              required_error: "Please select a key.",
            }),
            quota_id: z.number().optional(),
          }),
          operator: z.string({
            required_error: "Please select an operator.",
          }),
          value: z.string({
            required_error: "Please set a value.",
          }),
          value_from: z.string({
            required_error: "Please set a value.",
          }),
          value_to: z.string({
            required_error: "Please set a value.",
          }),
          value_list: z.string({
            required_error: "Please set a value.",
          }),
          value_arr: z.array(z.string()),
        })
        .optional()
    )
    .optional(),
})
  .superRefine((values, ctx) => {
    if (
      values.data_field === "other" &&
      values.custom_data_field.trim().length === 0
    ) {
      ctx.addIssue({
        path: ["custom_data_field"],
        code: z.ZodIssueCode.custom,
        message: "Please provide a data field or math formula",
      });
    }
  });

type DealSelectorSchema = z.infer<typeof dealSelectorSchema>;

interface StepDealSelectorProps {
  tokens: any[] | undefined;
}

export function DealSelector({ tokens }: StepDealSelectorProps) {
  const { onNext, onPrev } = useStepper();

  async function handleNext() {
    const isValid = await form.trigger();
    if (isValid) onNext();
  }

  const condition = {
    key: {
      key_name: "",
      quota_id: undefined,
    },
    operator: "",
    value: "",
    value_from: "",
    value_to: "",
    value_list: "",
    value_arr: [],
  };

  const defaultValues: Partial<DealSelectorSchema> = {
    metric: "deals_closed",
    filters: [],
    data_field: "value",
    custom_data_field: "",
    // quotas: [],
  };

  const form = useForm<DealSelectorSchema>({
    resolver: zodResolver(dealSelectorSchema),
    defaultValues,
    mode: "onChange",
  });

  // const { fields: quotaFields, append: appendQuota, remove: removeQuota } = useFieldArray({
  //   name: "quotas",
  //   control: form.control,
  // });

  const { fields: filterFields, append: appendFilter, remove: removeFilter } = useFieldArray({
    name: "filters",
    control: form.control,
  });

  return (
    <div className="flex flex-row gap-x-10 justify-stretch">
      {/* Form */}
      <div className="flex flex-col justify-between gap-y-10 flex-1 min-h-[300px]">
        <Form {...form}>
          <form onSubmit={() => { }} className="flex flex-col gap-y-6">
            {/* <div className="flex flex-col gap-y-3"> */}
            {/*   <FormLabel>Quotas</FormLabel> */}
            {/*   <div className="space-y-2"> */}
            {/*     {quotaFields.map((field, index) => ( */}
            {/*       <div key={index} className="flex flex-row gap-2 items-start"> */}
            {/*         <FormField */}
            {/*           control={form.control} */}
            {/*           key={`${field.id}.quotas.${index}.key`} */}
            {/*           name={`quotas.${index}.key`} */}
            {/*           render={({ field: { value, onChange } }) => ( */}
            {/*             <QuotaCombobox value={value} onChange={onChange} /> */}
            {/*           )} */}
            {/*         /> */}
            {/*         <FormField */}
            {/*           control={form.control} */}
            {/*           key={`${field.id}.quotas.${index}.operator`} */}
            {/*           name={`quotas.${index}.operator`} */}
            {/*           render={({ field: { value, onChange } }) => ( */}
            {/*             <ConditionCombobox2 */}
            {/*               value={value} */}
            {/*               onChange={onChange} */}
            {/*               commissionBasis="deal_value" */}
            {/*               selectedKey={ */}
            {/*                 form.watch(`quotas.${index}.key`)?.key_name || "" */}
            {/*               } */}
            {/*             /> */}
            {/*           )} */}
            {/*         /> */}
            {/**/}
            {/*         {["is", "gte", "lte", "lt", "gt"].includes( */}
            {/*           form.watch(`quotas.${index}.operator`) */}
            {/*         ) && ( */}
            {/*             <FormField */}
            {/*               control={form.control} */}
            {/*               key={`${field.id}.quotas.${index}.value`} */}
            {/*               name={`quotas.${index}.value`} */}
            {/*               render={({ field }) => ( */}
            {/*                 <FormItem> */}
            {/*                   <FormControl> */}
            {/*                     <Input */}
            {/*                       className="h-9" */}
            {/*                       placeholder="Value" */}
            {/*                       {...field} */}
            {/*                     /> */}
            {/*                   </FormControl> */}
            {/*                   <FormMessage /> */}
            {/*                 </FormItem> */}
            {/*               )} */}
            {/*             /> */}
            {/*           )} */}
            {/*         {form.watch(`quotas.${index}.operator`) === "range" && ( */}
            {/*           <FormField */}
            {/*             control={form.control} */}
            {/*             key={`${field.id}.quotas.${index}.value_from`} */}
            {/*             name={`filters.${index}.value_from`} */}
            {/*             render={({ field }) => ( */}
            {/*               <FormItem> */}
            {/*                 <FormControl> */}
            {/*                   <Input */}
            {/*                     className="h-9" */}
            {/*                     placeholder="From value" */}
            {/*                     {...field} */}
            {/*                   /> */}
            {/*                 </FormControl> */}
            {/*                 <FormMessage /> */}
            {/*               </FormItem> */}
            {/*             )} */}
            {/*           /> */}
            {/*         )} */}
            {/*         {form.watch(`quotas.${index}.operator`) === "range" && ( */}
            {/*           <FormField */}
            {/*             control={form.control} */}
            {/*             key={`${field.id}.quotas.${index}.value_to`} */}
            {/*             name={`quotas.${index}.value_to`} */}
            {/*             render={({ field }) => ( */}
            {/*               <FormItem> */}
            {/*                 <FormControl> */}
            {/*                   <Input */}
            {/*                     className="h-9" */}
            {/*                     placeholder="To value" */}
            {/*                     {...field} */}
            {/*                   /> */}
            {/*                 </FormControl> */}
            {/*                 <FormMessage /> */}
            {/*               </FormItem> */}
            {/*             )} */}
            {/*           /> */}
            {/*         )} */}
            {/*         {(form.watch(`quotas.${index}.operator`) === "in" || */}
            {/*           form.watch(`quotas.${index}.operator`) === */}
            {/*           "not_in") && ( */}
            {/*             <FormField */}
            {/*               control={form.control} */}
            {/*               key={`${field.id}.quotas.${index}.value_list`} */}
            {/*               name={`quotas.${index}.value_list`} */}
            {/*               render={({ field }) => ( */}
            {/*                 <FormItem> */}
            {/*                   <FormControl> */}
            {/*                     <Input */}
            {/*                       className="h-9" */}
            {/*                       placeholder="one,two,three" */}
            {/*                       {...field} */}
            {/*                     /> */}
            {/*                   </FormControl> */}
            {/*                   <FormMessage /> */}
            {/*                 </FormItem> */}
            {/*               )} */}
            {/*             /> */}
            {/*           )} */}
            {/*         <Button */}
            {/*           type="button" */}
            {/*           variant="ghost" */}
            {/*           size="sm" */}
            {/*           onClick={() => removeQuota(index)} */}
            {/*         > */}
            {/*           <XIcon className="h-4 w-4" /> */}
            {/*         </Button> */}
            {/*       </div> */}
            {/*     ))} */}
            {/*     <Button */}
            {/*       type="button" */}
            {/*       variant="outline" */}
            {/*       size="sm" */}
            {/*       className="mt-2" */}
            {/*       onClick={() => appendQuota(condition)} */}
            {/*     > */}
            {/*       <Plus className="mr-1 h-4 w-4" /> */}
            {/*       Add Quota */}
            {/*     </Button> */}
            {/*   </div> */}
            {/* </div> */}

            <FormField
              control={form.control}
              name="metric"
              render={({ field }) => (
                <FieldGroup className="w-full max-w-xs">
                  <FieldSet>
                    <FieldLegend variant="label">
                      Metric
                    </FieldLegend>
                    <RadioGroup
                      defaultValue={field.value}
                      className="flex flex-row gap-x-2"
                      onValueChange={field.onChange}
                    >
                      <FieldLabel htmlFor="deals_closed">
                        <Field orientation="horizontal">
                          <FieldContent className="w-24">
                            <FieldTitle>Deals won</FieldTitle>
                          </FieldContent>
                          <RadioGroupItem value="deals_closed" id="deals_closed" className="invisible" />
                        </Field>
                      </FieldLabel>
                      <FieldLabel htmlFor="deals_created">
                        <Field orientation="horizontal">
                          <FieldContent className="w-24">
                            <FieldTitle>Deals created</FieldTitle>
                          </FieldContent>
                          <RadioGroupItem value="deals_created" id="deals_created" className="invisible" />
                        </Field>
                      </FieldLabel>
                    </RadioGroup>
                  </FieldSet>
                </FieldGroup>
              )}
            />

            <FormField
              control={form.control}
              name="data_field"
              render={({ field }) => (
                <FormItem className="space-y-3">
                  <FormLabel>Data Field</FormLabel>
                  <FormControl>
                    <RadioGroup
                      onValueChange={field.onChange}
                      defaultValue={field.value}
                      className="flex flex-col space-y-1"
                    >
                      <FormItem className="flex items-center space-x-3 space-y-0">
                        <FormControl>
                          <RadioGroupItem value="value" />
                        </FormControl>
                        <FormLabel className="font-normal">
                          Value
                        </FormLabel>
                      </FormItem>
                      <FormItem className="flex items-center space-x-3 space-y-0">
                        <FormControl>
                          <RadioGroupItem value="onboarding_value" />
                        </FormControl>
                        <FormLabel className="font-normal">
                          Onboarding Value
                        </FormLabel>
                      </FormItem>
                      <FormItem className="flex items-center space-x-3 space-y-0">
                        <FormControl>
                          <RadioGroupItem value="quantity" />
                        </FormControl>
                        <FormLabel className="font-normal">
                          {form.watch("metric") === "deals_created"
                            ? "Number of deals created"
                            : "Number of deals closed"}
                        </FormLabel>
                      </FormItem>
                      <FormItem className="flex items-center space-x-3 space-y-0">
                        <FormControl>
                          <RadioGroupItem value="other" />
                        </FormControl>
                        <FormLabel className="font-normal">
                          Other
                        </FormLabel>
                      </FormItem>
                    </RadioGroup>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="custom_data_field"
              render={({ field }) => (
                <>
                  {form.watch("data_field") === "other" && (
                    <div className="flex flex-col gap-y-2">
                      <FormControl>
                        <Input
                          placeholder="invoiced_amount * 12"
                          className="w-60 h-8"
                          {...field}
                        />
                      </FormControl>
                      <FormDescription className="text-xs">
                        Name any deal field or write any math formula
                      </FormDescription>
                      <FormMessage />
                    </div>
                  )}
                </>
              )}
            />


            <div className="flex flex-col gap-y-3">
              <FormLabel>Criteria</FormLabel>
              <div className="space-y-2">
                {filterFields.map((field, index) => (
                  <div key={index} className="flex flex-row gap-2 items-start">
                    <FormField
                      control={form.control}
                      key={`${field.id}.filters.${index}.key`}
                      name={`filters.${index}.key`}
                      render={({ field: { value, onChange } }) => (
                        <FilterCombobox value={value} onChange={onChange} />
                      )}
                    />
                    {form.watch(`filters.${index}.key.key_name`) !== "deal_providers" &&
                      form.watch(`filters.${index}.key.key_name`) !== "deal_types" &&
                      form.watch(`filters.${index}.key.key_name`) !== "deal_role" &&
                      form.watch(`filters.${index}.key.key_name`) !== "custom" &&
                      (
                        <FormField
                          control={form.control}
                          key={`${field.id}.filters.${index}.operator`}
                          name={`filters.${index}.operator`}
                          render={({ field: { value, onChange } }) => (
                            <ConditionCombobox2
                              value={value}
                              onChange={onChange}
                              commissionBasis="deal_value"
                              selectedKey={
                                form.watch(`filters.${index}.key`)?.key_name || ""
                              }
                            />
                          )}
                        />
                      )}
                    {form.watch(`filters.${index}.key.key_name`) === "deal_providers" && (
                      <FormField
                        control={form.control}
                        key={`${field.id}.filters.${index}.value_arr`}
                        name={`filters.${index}.value_arr`}
                        render={({ field }) => (
                          <FormItem>
                            <FormControl>
                              <MultiSelect
                                options={getDealProvidersMultiSelectOptions(tokens)}
                                onValueChange={field.onChange}
                                defaultValue={field.value as any}
                                placeholder="Select providers from list"
                                variant="inverted"
                                animation={0}
                                maxCount={3}
                                {...field}
                              />
                            </FormControl>
                            <FormMessage />
                          </FormItem>
                        )}
                      />
                    )}

                    {form.watch(`filters.${index}.key.key_name`) === "deal_types" && (
                      <FormField
                        control={form.control}
                        key={`${field.id}.filters.${index}.value_arr`}
                        name={`filters.${index}.value_arr`}
                        render={({ field }) => (
                          <FormItem>
                            <FormControl>
                              <MultiSelect
                                options={getDealTypesMultiSelectOptions()}
                                onValueChange={field.onChange}
                                defaultValue={field.value as any}
                                placeholder="Select types from list"
                                variant="inverted"
                                animation={0}
                                maxCount={3}
                                {...field}
                              />
                            </FormControl>
                            <FormMessage />
                          </FormItem>
                        )}
                      />
                    )}

                    {form.watch(`filters.${index}.key.key_name`) === "deal_role" && (
                      <FormField
                        control={form.control}
                        key={`${field.id}.filters.${index}.value_arr`}
                        name={`filters.${index}.value_arr`}
                        render={({ field }) => (
                          <FormItem>
                            <FormControl>
                              <MultiSelect
                                options={getDealRolesMultiSelectOptions()}
                                onValueChange={field.onChange}
                                defaultValue={field.value as any}
                                placeholder="Select types from list"
                                variant="inverted"
                                animation={0}
                                maxCount={3}
                                {...field}
                              />
                            </FormControl>
                            <FormMessage />
                          </FormItem>
                        )}
                      />
                    )}

                    {form.watch(`filters.${index}.key.key_name`) === "custom" && (
                      <FormField
                        control={form.control}
                        key={`${field.id}.filters.${index}.value`}
                        name={`filters.${index}.value`}
                        render={({ field }) => (
                          <FormItem>
                            <FormControl>
                              <Input
                                className="h-9 w-96"
                                placeholder="invoice_length / billing_term > 12"
                                {...field}
                              />
                            </FormControl>
                            <FormMessage />
                          </FormItem>
                        )}
                      />
                    )}

                    {["is", "gte", "lte", "lt", "gt"].includes(
                      form.watch(`filters.${index}.operator`)
                    ) && (
                        <FormField
                          control={form.control}
                          key={`${field.id}.filters.${index}.value`}
                          name={`filters.${index}.value`}
                          render={({ field }) => (
                            <FormItem>
                              <FormControl>
                                <Input
                                  className="h-9"
                                  placeholder="Value"
                                  {...field}
                                />
                              </FormControl>
                              <FormMessage />
                            </FormItem>
                          )}
                        />
                      )}
                    {form.watch(`filters.${index}.operator`) === "range" && (
                      <FormField
                        control={form.control}
                        key={`${field.id}.filters.${index}.value_from`}
                        name={`filters.${index}.value_from`}
                        render={({ field }) => (
                          <FormItem>
                            <FormControl>
                              <Input
                                className="h-9"
                                placeholder="From value"
                                {...field}
                              />
                            </FormControl>
                            <FormMessage />
                          </FormItem>
                        )}
                      />
                    )}
                    {form.watch(`filters.${index}.operator`) === "range" && (
                      <FormField
                        control={form.control}
                        key={`${field.id}.filters.${index}.value_to`}
                        name={`filters.${index}.value_to`}
                        render={({ field }) => (
                          <FormItem>
                            <FormControl>
                              <Input
                                className="h-9"
                                placeholder="To value"
                                {...field}
                              />
                            </FormControl>
                            <FormMessage />
                          </FormItem>
                        )}
                      />
                    )}
                    {(form.watch(`filters.${index}.operator`) === "in" ||
                      form.watch(`filters.${index}.operator`) ===
                      "not_in") && (
                        <FormField
                          control={form.control}
                          key={`${field.id}.filters.${index}.value_list`}
                          name={`filters.${index}.value_list`}
                          render={({ field }) => (
                            <FormItem>
                              <FormControl>
                                <Input
                                  className="h-9"
                                  placeholder="one,two,three"
                                  {...field}
                                />
                              </FormControl>
                              <FormMessage />
                            </FormItem>
                          )}
                        />
                      )}
                    {(form.watch(`filters.${index}.operator`) === "deal_types") && (
                      <FormField
                        control={form.control}
                        key={`${field.id}.filters.${index}.value_list`}
                        name={`filters.${index}.value_list`}
                        render={({ field }) => (
                          <FormItem>
                            <FormControl>
                              <Input
                                className="h-9"
                                placeholder="new,existing"
                                {...field}
                              />
                            </FormControl>
                            <FormMessage />
                          </FormItem>
                        )}
                      />
                    )}
                    <Button
                      type="button"
                      variant="ghost"
                      size="sm"
                      onClick={() => removeFilter(index)}
                    >
                      <XIcon className="h-4 w-4" />
                    </Button>
                  </div>
                ))}
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  className="mt-2"
                  onClick={() => appendFilter(condition)}
                >
                  <Plus className="mr-1 h-4 w-4" />
                  Add criteria
                </Button>
              </div>
            </div>

          </form>
        </Form>

        <StepperButtons
          onNext={handleNext}
          onPrev={onPrev}
        />
      </div>
      <StepperSidebar />
    </div>
  );
}
